import { gsap } from "gsap";

import { ScrollTrigger } from "gsap/ScrollTrigger";
import { TextPlugin } from "gsap/TextPlugin.js";

export function setCookie(name, value, days) {
    var now = new Date();
    var expTime = now.getTime() + days * 24 * 60 * 60 * 1000;
    var expDate = new Date(expTime);
    document.cookie = name + "=" + value + "; EXPIRES=" + expDate.toGMTString() + "; path=/";
}
export function getCookie(name) {

    var start = document.cookie.indexOf(name + "=");
    if (start == -1)
        return null;
    var len = start + name.length + 1;
    var end = document.cookie.indexOf(";", len);
    if (end == -1)
        end = document.cookie.length;
    return document.cookie.substring(len, end)
}

export function initializeMap(map0) {

    var mapData = JSON.parse(map0.dataset.map.replace(/'/g, '"'));

    var mapOptions = {
        center: new google.maps.LatLng(mapData[0]['map-lat'], mapData[0]['map-lng']),
        zoom: 14,
        panControl: false,
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: true,
        overviewMapControl: false,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        scrollwheel: false,
        styles: [
            {
                stylers: [
                    { saturation: -100 }
                ]
            }
        ]
    };
    var image = "../wp-content/themes/avangardo/images/marker.png";
    var map = new google.maps.Map(map0, mapOptions);
    map.myOrigins = map.getCenter();
    var bounds = new google.maps.LatLngBounds();

    mapData.forEach(function (elem) {
        elem.marker = new google.maps.Marker({
            position: new google.maps.LatLng(elem['map-lat'], elem['map-lng']),
            map: map,
            icon: image
        });
        bounds.extend(elem.marker.position);
        google.maps.event.addListener(elem.marker, 'click', function () {
            window.open(elem['map-link']);
        });
    });
    if (mapData.length > 1) {
        map.fitBounds(bounds);
    }

}


/**
* init menu trigger (onClisk)
 */
export const initMenuTrigger = () => {
    const menuTrigger = document.querySelector('.menuTrigger');
    if (menuTrigger) {
        document.querySelectorAll('.menuTrigger').forEach((item) => item.addEventListener('click', e => {
            document.body.classList.toggle('showMenu');
        }));
    }
}

/**
    * init open link in new tab on click for class "newWindow"
    */
export const initOpenInNewTab = () => {
    const newWindow = document.querySelectorAll('.newWindow');
    if (newWindow && newWindow.length > 0) {
        newWindow.forEach(item =>
            item.addEventListener('click', e => {
                e.preventDefault();

                window.open(item.href);
                return false;
            })
        );
    }
}

/**
 * add scroll class to body on Scroll
 */
export const addScollClass = (topPosition, className) => {
    if (!!window.IntersectionObserver) {
        let topHeaderObserver = new IntersectionObserver(entries => {
            if (entries[0].intersectionRatio == 0) {
                document.body.classList.add(className);
            } else {
                document.body.classList.remove(className);
            }
        });
        const trigger = document.createElement('div');
        trigger.style.position = 'absolute';
        trigger.style.top = topPosition;
        document.body.appendChild(trigger);
        topHeaderObserver.observe(trigger);
    }
}

/**
 * add/remove hideScrolledMenu class to body based on scroll direction and position
 */
export const addHideScrolledMenuClass = () => {
    let lastScrollY = window.scrollY;
    let halfScreenHeight = window.innerHeight;


    const handleScroll = () => {
        const currentScrollY = window.scrollY;

        // Sprawdzamy czy przekroczyliśmy połowę wysokości ekranu
        if (currentScrollY > halfScreenHeight) {
            // Sprawdzamy kierunek scrollowania
            if (currentScrollY > lastScrollY) {
                // Scrollujemy w dół - dodajemy klasę
                document.body.classList.add('hideScrolledMenu');
            } else {
                // Scrollujemy w górę - usuwamy klasę
                document.body.classList.remove('hideScrolledMenu');
            }
        } else {
            // Jeśli jesteśmy powyżej połowy ekranu, zawsze usuwamy klasę
            document.body.classList.remove('hideScrolledMenu');
        }

        lastScrollY = currentScrollY;
    };

    // Dodajemy event listener z throttling dla lepszej wydajności
    let ticking = false;
    const throttledScroll = () => {
        if (!ticking) {
            requestAnimationFrame(() => {
                handleScroll();
                ticking = false;
            });
            ticking = true;
        }
    };

    window.addEventListener('scroll', throttledScroll, { passive: true });

    // Aktualizujemy halfScreenHeight przy zmianie rozmiaru okna
    window.addEventListener('resize', () => {
        halfScreenHeight = window.innerHeight / 2;
    }, { passive: true });
}



/**
 * add class 'gallery-item', fix for fancybox plugin
 * @param {string} cn 
 */
export const galleryAddItemClass = (cn) => {
    const galleryItemFancybox = document.querySelectorAll(cn);
    if (galleryItemFancybox && galleryItemFancybox.length > 0) {
        galleryItemFancybox.forEach(item => {
            item.classList.add('gallery-item');
        });
    }
}

/**
 * add id to gallery holder, fix for fancybox plugin
 * @param {string} gallery 
 */
export const addFancyboxFixForGallery = (gallery) => {
    const galleryFancybox = document.querySelectorAll(gallery);
    if (galleryFancybox && galleryFancybox.length > 0) {
        galleryFancybox.forEach(gallery => {
            const galleryAnchors = gallery.querySelectorAll(':scope a');
            const galeeryId = 'gal' + (Math.floor(Math.random() * 100));
            if (galleryAnchors && galleryAnchors.length > 0) {
                galleryAnchors.forEach(galeeryAnchor => {
                    galeeryAnchor.dataset.fancybox = galeeryId;
                    galeeryAnchor.dataset.caption = galeeryAnchor.nextSibling ? galeeryAnchor.nextSibling.innerHTML : '';
                });
            }
        });
    }
}

/**
 * add close on click for cookies box
 */
const hideCookies = () => {
    document.querySelector('.cookies').classList.add('hide');
}
export const addCloseCookies = () => {
    const cookieBtn = document.querySelector('.cookies__close');
    if (cookieBtn) {
        cookieBtn.addEventListener('click', e => {
            setCookie('hideCookieAlert', 1, 360);
            hideCookies();
            return false;
        });
    }
    if (getCookie('hideCookieAlert')) {
        hideCookies();
    }
}



/**
 * init form script fix
 */
export const initForm = () => {

    var wpcf7Elm = document.querySelectorAll('.wpcf7');
    const inputs = document.querySelectorAll(
        '.wpcf7 input[type=text], ' +
        '.wpcf7 input[type=email], ' +
        '.wpcf7 input[type=tel], ' +
        '.wpcf7 textarea, ' +
        '.wpcf7 select'
    );
    if (inputs) {
        inputs.forEach(item => {

            if (item.nodeName == 'SELECT') item.value = '';
            item.addEventListener('focus', e => e.target.parentNode.parentNode.querySelector(':scope label').classList.add('show'));
            item.addEventListener('focusout', e => {
                if (e.target.value == '' || e.target.value == null) {
                    e.target.parentNode.parentNode.querySelector(':scope label').classList.remove('show')
                }
            });

            var observer = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                    if (mutation.attributeName === 'class' && mutation.target.classList.contains('wpcf7-not-valid')) {
                        mutation.target.parentNode.parentNode.classList.add('error');
                    } else if (mutation.attributeName === 'class') {
                        mutation.target.parentNode.parentNode.classList.remove('error');

                    }
                });

            });

            observer.observe(item, { attributes: true });
        });
    }

    let submitInputs = document.querySelectorAll('.wpcf7 input[type=submit]');
    var observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.attributeName === 'disabled' && mutation.target.disabled) {
                mutation.target.removeAttribute('disabled');
            }
        });
    });
    submitInputs.forEach(button => {
        observer.observe(button, { attributes: true });
        button.removeAttribute('disabled');
    });



    if (wpcf7Elm) {
        wpcf7Elm.forEach(wpcf7ElmItem => {
            wpcf7ElmItem.addEventListener('wpcf7invalid', function (event) {
                document.querySelectorAll('.wpcf7-not-valid')
                    .forEach((item) => {
                        if (item.value !== "") {
                            item.parentNode.parentNode.querySelector(':scope label').classList.add('show');
                        }
                    });
                //jQuery('html,body').animate({ scrollTop: ($(wpcf7ElmItem).offset().top - 100) + 'px' }, 500);
            }, false);
            wpcf7ElmItem.addEventListener('wpcf7mailsent', function (event) {
                document.querySelectorAll('.wpcf7 input').forEach((item) => {
                    const label = item.parentNode.parentNode.querySelector(':scope label');
                    if (label) {
                        label.classList.remove('show');
                    }
                });
                //  jQuery('html,body').animate({ scrollTop: ($(wpcf7ElmItem).offset().top - 100) + 'px' }, 500);

                wpcf7ElmItem.closest('.contactPopup').classList.add('send');
                if (wpcf7ElmItem.closest('.contactPopup')) {
                    wpcf7ElmItem.reset();
                }

            }, false);


        });

    }


    let rodo = document.querySelectorAll('.wpcf7 .wpcf7-form-control.wpcf7-acceptance');
    if (rodo) {
        rodo.forEach(item => {
            const arrow = document.createElement('span');
            arrow.className = 'rodo_arrow';
            item.appendChild(arrow);
            arrow.addEventListener('click', e => {
                item.classList.toggle('slideDown');

            });
        });
    }

}



/**
 * google map (API) init
 */
export const googleMapInit = () => {
    var map = document.querySelector('.contactMap');
    if (map && typeof google !== 'undefined') {
        google.maps.event.addDomListener(window, 'load', function () {
            initializeMap(map);
        });

    }
}



export const initLoadNews = () => {
    if (!!window.IntersectionObserver) {
        let newsCanBeLoaded = true;
        const newsAjaxTrigger = document.querySelector('.newsAjaxTrigger');
        let addNewsObserver = new IntersectionObserver(entries => {
            if (entries[0].isIntersecting) {
                if (newsCanBeLoaded) {
                    loadNews();
                }
            }
        });

        if (newsAjaxTrigger) {
            addNewsObserver.observe(newsAjaxTrigger);
        }

        const loadNews = () => {
            const newsAjaxTrigger = document.querySelector('.newsAjaxTrigger');
            if (newsAjaxTrigger) {
                newsCanBeLoaded = false;
                newsAjaxTrigger.classList.add('show');
                const formData = new FormData();
                formData.append('action', 'loadmore');
                formData.append('query', ajaxParams.posts);
                formData.append('page', ajaxParams.current_page);
                fetch(ajaxParams.ajaxurl, {
                    method: "post",
                    body: formData
                })
                    .then(res => res.text())
                    .then(res => {
                        if (res) {
                            newsCanBeLoaded = true;
                            ajaxParams.current_page++;
                            newsAjaxTrigger.classList.remove('show');
                            document.querySelector('.newsList').insertAdjacentHTML('beforeend', res);
                        } else {
                            newsCanBeLoaded = false;
                            document.querySelector('.newsAjaxTrigger').remove();
                            addNewsObserver.disconnect();
                        }

                    });
            }

        }
    }
}

const faqServiceTrigger = (trigger, faqHolder) => {
    const tParent = trigger.parentNode;
    const tContent = tParent.querySelector(':scope .gFaq__content');

    [...faqHolder.querySelectorAll(':scope .gFaq__item.active')].forEach((item) => {
        if (!item.isSameNode(tParent)) {
            item.classList.remove('active');
            jQuery(item.querySelector(':scope .gFaq__content')).stop(true, true).slideUp(500)
        }
    });

    if (!tParent.classList.contains('active')) {
        typeof jQuery == "function" ? jQuery(tContent).stop(true, true).slideDown(500) : null;
    } else {
        typeof jQuery == "function" ? jQuery(tContent).stop(true, true).slideUp(500) : null;
    }
    tParent.classList.toggle('active');

}

export const faqService = () => {
    const faq = document.querySelectorAll('.gFaq');

    if (faq.length > 0) {
        [...faq].forEach((faqItem) => {
            const triggers = faqItem.querySelectorAll(':scope .gFaq__trigger');
            if (triggers.length > 0) {
                [...triggers].forEach((trigger) => {
                    trigger.addEventListener('click', () => faqServiceTrigger(trigger, faqItem));
                });
            }

        });
    }

}

export const initGallerySlider = () => {
    let galleries = document.querySelectorAll('.wp-block-gallery.is-style-gallerySlider');
    if (galleries.length > 0) {
        [...galleries].forEach((gallery) => {
            let galHolder = document.createElement('div');
            let caption = gallery.querySelector(':scope .blocks-gallery-caption');
            galHolder.classList.add('wp-block-gallery__slider');
            galHolder.classList.add('slickSliderUi');
            let images = gallery.querySelectorAll(':scope .wp-block-image');
            [...images].forEach((image) => {
                galHolder.appendChild(image);
            });
            gallery.insertBefore(galHolder, gallery.firstChild);

            typeof jQuery == "function" ? $(galHolder).slick({
                infinite: false,
                arrows: true,
                dots: true,
                autoplay: false,
                speed: 500,
                autoplaySpeed: 3000,
                slidesToShow: 3,
                slidesToScroll: 1,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                        }
                    }
                ]
            }) : null;

        });
    }
}

export const initLazyBg = (className = 'lazyBg') => {
    let lazyBgList = [].slice.call(document.querySelectorAll('.' + className));

    if ("IntersectionObserver" in window) {
        let lazyImageObserver = new IntersectionObserver(function (entries, observer) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    entry.target.classList.remove(className);
                    lazyImageObserver.unobserve(entry.target);
                }
            });
        }, {
            rootMargin: '150px 0px'
        });
        lazyBgList.forEach(function (lazyBg) {
            lazyImageObserver.observe(lazyBg);
        });
    }

}

export const animUp = (className = 'animUp') => {
    let lazyBgList = [].slice.call(document.querySelectorAll('.' + className));

    if ("IntersectionObserver" in window) {
        let lazyImageObserver = new IntersectionObserver(function (entries, observer) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    entry.target.classList.remove(className);
                    lazyImageObserver.unobserve(entry.target);
                }
            });
        }, {
            rootMargin: '150px 0px'
        });
        lazyBgList.forEach(function (lazyBg) {
            lazyImageObserver.observe(lazyBg);
        });
    }


}

export const initShow = (className = 'animUp', classNameAdd = 'show') => {
    let showList = [].slice.call(document.querySelectorAll('.' + className));

    if ("IntersectionObserver" in window) {
        let lazyImageObserver = new IntersectionObserver(function (entries, observer) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    entry.target.classList.add(classNameAdd);
                    lazyImageObserver.unobserve(entry.target);
                } /*else {
                    entry.target.classList.remove(classNameAdd);
                }*/
            });
        }, {
            rootMargin: '0px 0px -15% 0px'
        });
        showList.forEach(function (show) {
            lazyImageObserver.observe(show);
        });
    }

}

export function initVideoMouseControl() {
    const video = document.getElementById('blobVideo');
    if (!video) return;

    let ticking = false;
    let lastMouseX = 0;
    let lastMouseY = 0;
    let mouseSpeed = 0;
    let speedDecayInterval = null;

    const basePlaybackRate = 0.7; // Podstawowa prędkość gdy mysz się nie rusza
    const maxPlaybackRate = 3; // Maksymalna prędkość przy szybkim ruchu myszy

    const calculateMouseSpeed = (currentX, currentY) => {
        const deltaX = currentX - lastMouseX;
        const deltaY = currentY - lastMouseY;
        const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);

        lastMouseX = currentX;
        lastMouseY = currentY;

        return distance;
    };

    const updateVideoSpeed = () => {
        // Mapuj prędkość myszy na prędkość video
        // mouseSpeed może być od 0 do ~50+ (w zależności od szybkości ruchu)
        const speedMultiplier = Math.min(mouseSpeed / 20, 2); // Normalizuj do 0-2
        const playbackRate = basePlaybackRate + (speedMultiplier * (maxPlaybackRate - basePlaybackRate));

        video.playbackRate = Math.min(maxPlaybackRate, Math.max(0.5, playbackRate));
        ticking = false;
    };

    const handleMouseMove = (e) => {
        if (!ticking) {
            requestAnimationFrame(() => {
                mouseSpeed = calculateMouseSpeed(e.clientX, e.clientY);
                updateVideoSpeed();

                // Restart decay timer
                clearInterval(speedDecayInterval);
                speedDecayInterval = setInterval(() => {
                    mouseSpeed *= 0.95; // Zmniejsz prędkość o 15% co 50ms

                    if (mouseSpeed < 0.5) {
                        mouseSpeed = 0;
                        video.playbackRate = basePlaybackRate;
                        clearInterval(speedDecayInterval);
                        speedDecayInterval = null;
                    } else {
                        updateVideoSpeed();
                    }
                }, 50);
            });
            ticking = true;
        }
    };

    // Inicjalizuj pozycję myszy
    const initMousePosition = (e) => {
        lastMouseX = e.clientX;
        lastMouseY = e.clientY;
        document.removeEventListener('mousemove', initMousePosition);
        document.addEventListener('mousemove', handleMouseMove, { passive: true });
    };

    // Event listeners
    document.addEventListener('mousemove', initMousePosition, { passive: true });

    // Przywróć podstawową prędkość gdy mysz opuści okno
    document.addEventListener('mouseleave', () => {
        mouseSpeed = 0;
        video.playbackRate = basePlaybackRate;
        clearInterval(speedDecayInterval);
        speedDecayInterval = null;
    }, { passive: true });

    // Cleanup przy pauzowaniu video
    video.addEventListener('pause', () => {
        clearInterval(speedDecayInterval);
        speedDecayInterval = null;
    });
}

export const initFooterWriting = () => {
    gsap.registerPlugin(ScrollTrigger, TextPlugin);

    const footerTitle = document.querySelector('.footer1__title');
    if (!footerTitle) return;

    const text1Element = footerTitle.querySelector('.text1');
    const text2Element = footerTitle.querySelector('.text2');
    const text3Element = footerTitle.querySelector('.text3');
    const text4Element = footerTitle.querySelector('.text4');
    const text5Element = footerTitle.querySelector('.text5');

    // Sprawdzamy czy wszystkie elementy istnieją
    if (!text2Element || !text3Element || !text4Element || !text5Element) return;

    const text1 = text1Element?.dataset.text || '';
    const text2 = text2Element.dataset.text;
    const text3 = text3Element.dataset.text;
    const text4 = text4Element.dataset.text;
    const text5 = text5Element.dataset.text;

    // Resetujemy tekst na początku
    gsap.set([text2Element, text3Element, text4Element, text5Element], {
        text: "",
        display: "inline-block"
    });

    // Tworzymy timeline z ScrollTrigger
    const tl = gsap.timeline({
        scrollTrigger: {
            trigger: footerTitle,
            start: "bottom 85%",
            //  end: "bottom 15%",
            // toggleActions: "play none none reverse",
            once: true, // Animacja uruchomi się tylko raz
            //  markers: true,
        }
    });

    // Sekwencja animacji tekstu
    tl.to(text2Element, {
        duration: text2.length * 0.04,
        text: text2,
        ease: "none"
    })
        .to(text2Element, {
            duration: text2.length * 0.005,
            text: '',
            delay: 1,
            ease: "none"
        })
        .set(text2Element, {
            display: "none"
        })
        .to(text3Element, {
            duration: text3.length * 0.04,
            text: text3,
            ease: "none"
        })
        .to(text3Element, {
            duration: text3.length * 0.005,
            text: '',
            delay: 1,
            ease: "none"
        })
        .set(text3Element, {
            display: "none"
        })
        .to(text4Element, {
            duration: text4.length * 0.04,
            text: text4,
            ease: "none"
        })
        .to(text4Element, {
            duration: text4.length * 0.005,
            text: '',
            delay: 1,
            ease: "none"
        })
        .set(text4Element, {
            display: "none"
        })
        .to(text5Element, {
            duration: text5.length * 0.04,
            text: text5,
            ease: "none"
        });
}

export function scrollSlider(holder, holderSlider, sliderItemsToAnim, sliderItem) {
    var sliderContainer = $(holder);
    var slider = $(holderSlider);
    var sliderItems = slider.find(sliderItemsToAnim);

    function roundTranslation(x) {
        return Math.round(x);
    }
    let timeoutOfscroll;


    gsap.to(slider, {
        x: () => {
            return - (slider.width() - sliderContainer.width() + 100);
        },
        ease: "none",
        scrollTrigger: {
            trigger: sliderContainer.parent(),
            start: "center 52%",
            end: () => { return "+=" + (slider.width() + 200) },
            scrub: 1,
            //  markers: true,
            pin: true,
            pinnedContainer: sliderContainer.parent(),
            onUpdate: function (progress, direction, isActive) {
            },
        }
    });
    if (sliderItems.length > 0) {
        let sliderItemanim = gsap.timeline({
            scrollTrigger: {
                trigger: slider,
                start: "top 120%",
                end: () => { return "+=" + (slider.width() + 200) },
                //  end: "bottom 40%",
                // thiggerEnd: sliderContainer,
                scrub: true,
                // markers: true,
            }
        });
        [...sliderItems].forEach((item, index) => {
            gsap.set(item, { opacity: 0 });
            sliderItemanim.to(item, {
                opacity: 1,
                ease: "linear",

            });
        });
    }




}

export const initLottieLoader = () => {
    let lottieScriptLoaded = false;
    let mutationObserver = null;
    let intersectionObserver = null;

    // Konfiguracja - selektory elementów które zawierają ukryte animacje
    const hiddenLottieContainers = [
        '.contactPopup'
    ];

    // Triggery które pokazują ukryte elementy
    const showTriggerSelectors = [
        '.mainHeader__contact a',
        '.show_popup_form',
        '[href="#show_popup_form"]',
        '.subpageHeader__quickFormBtn'
    ];

    const loadLottieScript = () => {
        if (lottieScriptLoaded) return Promise.resolve();

        //  console.log('Loading Lottie script...');
        return new Promise((resolve, reject) => {
            const script = document.createElement('script');
            script.src = 'https://unpkg.com/@lottiefiles/lottie-player@2.0.12/dist/lottie-player.js';
            script.onload = () => {
                lottieScriptLoaded = true;
                //   console.log('Lottie script loaded successfully');
                cleanup();
                resolve();
            };
            script.onerror = () => {
                console.error('Failed to load Lottie script');
                reject();
            };
            document.head.appendChild(script);
        });
    };

    const cleanup = () => {
        if (mutationObserver) {
            mutationObserver.disconnect();
            mutationObserver = null;
        }
        if (intersectionObserver) {
            intersectionObserver.disconnect();
            intersectionObserver = null;
        }
    };

    // Sprawdź czy element jest w ukrytym kontenerze
    const isInHiddenContainer = (element) => {
        for (let selector of hiddenLottieContainers) {
            if (element.closest(selector)) {
                return true;
            }
        }
        return false;
    };

    // Znajdź widoczne elementy Lottie (nie w ukrytych kontenerach)
    const getVisibleLottieElements = () => {
        const allLottieElements = document.querySelectorAll('lottie-player');
        const visibleElements = [];

        allLottieElements.forEach(element => {
            if (!isInHiddenContainer(element) && element.offsetParent !== null) {
                visibleElements.push(element);
            }
        });

        // console.log(`Found ${visibleElements.length} visible lottie elements (total: ${allLottieElements.length})`);
        return visibleElements;
    };

    // Obserwacja widoczności dla elementów w treści
    const observeLottieVisibility = (elements) => {
        if (elements.length === 0) return;

        if (!intersectionObserver) {
            intersectionObserver = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting && !lottieScriptLoaded) {
                        // console.log('Visible Lottie element detected on screen, loading script...');
                        loadLottieScript();
                    }
                });
            }, {
                rootMargin: '40% 0px 40% 0px',
                threshold: 0.1
            });
        }

        elements.forEach(element => {
            intersectionObserver.observe(element);
        });
    };

    // Dodaj event listenery do triggerów
    const setupClickTriggers = () => {
        showTriggerSelectors.forEach(selector => {
            document.querySelectorAll(selector).forEach(trigger => {
                trigger.addEventListener('click', () => {
                    if (!lottieScriptLoaded) {
                        // console.log('Trigger clicked, checking for hidden Lottie elements...');
                        // Sprawdź czy trigger może pokazać ukryte elementy z Lottie
                        const hasHiddenLottie = hiddenLottieContainers.some(containerSelector => {
                            const container = document.querySelector(containerSelector);
                            return container && container.querySelector('lottie-player');
                        });

                        if (hasHiddenLottie) {
                            //   console.log('Hidden Lottie elements found, loading script...');
                            loadLottieScript();
                        }
                    }
                });
            });
        });
    };

    // Sprawdzenie początkowe
    const checkForLottieElements = () => {
        const visibleLottieElements = getVisibleLottieElements();

        if (visibleLottieElements.length > 0) {
            //console.log('Setting up scroll observation for visible Lottie elements');
            observeLottieVisibility(visibleLottieElements);
            return true;
        }
        return false;
    };

    // Opóźnij inicjalizację o 100ms dla stabilności DOM
    setTimeout(() => {
        // Setup click triggers for hidden elements
        setupClickTriggers();

        // Check for visible elements
        const hasVisibleElements = checkForLottieElements();

        // Jeśli nie ma widocznych elementów, ustaw mutation observer dla dynamicznych
        if (!hasVisibleElements) {
            let throttleTimer = null;

            mutationObserver = new MutationObserver((mutations) => {
                if (lottieScriptLoaded) return;

                if (throttleTimer) return;
                throttleTimer = setTimeout(() => {
                    throttleTimer = null;

                    for (let mutation of mutations) {
                        if (mutation.type === 'childList') {
                            for (let node of mutation.addedNodes) {
                                if (node.nodeType === Node.ELEMENT_NODE) {
                                    if (node.tagName === 'LOTTIE-PLAYER' ||
                                        (node.querySelectorAll && node.querySelectorAll('lottie-player').length > 0)) {
                                        //  console.log('New Lottie elements detected, re-checking...');
                                        checkForLottieElements();
                                        return;
                                    }
                                }
                            }
                        }
                    }
                }, 200);
            });

            mutationObserver.observe(document.body, {
                childList: true,
                subtree: true,
                attributes: false,
                characterData: false
            });
        }
    }, 100);
};